import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { milestoneActions } from "../actions";
import milestoneApi from "../services/milestone.service";
import { generalActions } from "../actions";
import ACTIONS from "../constants";
import { milestonesPagination } from "../selectors/milestone.selector";
import { calculatePageSize } from "../../helpers/utils";

function* getMilestones(state) {
  try {
    yield put(milestoneActions.getMilestonesAttempt.pending);
    const milestoneItems = yield call(milestoneApi.getMilestones, state.payload);
    const pagination = JSON.parse(milestoneItems.headers["x-pagination"]);
    const data = {
      data: milestoneItems.data,
      pagination: pagination,
    };
    yield put(milestoneActions.getMilestonesAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(milestoneActions.getMilestonesAttempt.error(""));
    } else {
      yield put(milestoneActions.getMilestonesAttempt.error(error.message));
    }
  }
}


function* getMilestoneItemDetails(state) {
  try {
    yield put(milestoneActions.getMilestoneAttempt.pending);
    const milestoneItem = yield call(milestoneApi.getMilestone, state.payload);
    yield put(milestoneActions.getMilestoneAttempt.success(milestoneItem));
  } catch (error) {
    yield put(milestoneActions.getMilestoneAttempt.error(error.message));
  }
}

function* createMilestone(state) {
  try {
    yield put(milestoneActions.createMilestoneAttempt.pending);
    yield call(milestoneApi.createMilestone, state.payload.data);
    yield put(milestoneActions.createMilestoneAttempt.success());
    yield put(
      generalActions.showToast({
        title: `Milestone created successfully`,
        type: "success",
      })
    );
    if(state.payload.callback){
      state.payload.callback();
    }
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(milestoneActions.createMilestoneAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(milestoneActions.createMilestoneAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(milestoneActions.createMilestoneAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateMilestone(state) {
  try {
    yield put(milestoneActions.updateMilestoneAttempt.pending);

    yield call(milestoneApi.updateMilestone, {
      id: state.payload.id,
      data: state.payload.data,
    });

    yield put(milestoneActions.updateMilestoneAttempt.success());
    yield put(
      generalActions.showToast({
        title: `Milestone updated successfully`,
        type: "success",
      })
    );
    if(state.payload.callback){
      state.payload.callback();
    }
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(milestoneActions.updateMilestoneAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(milestoneActions.updateMilestoneAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(milestoneActions.updateMilestoneAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteMilestone(state) {
  try {
    yield put(milestoneActions.deleteMilestoneAttempt.pending);
    yield call(milestoneApi.deleteMilestone, state.payload.id);
    yield put(milestoneActions.deleteMilestoneAttempt.success());

    yield put(
      generalActions.showToast({
        title: "Milestone deleted successfully",
        type: "success",
      })
    );
    if(state.payload.callback){
      state.payload.callback();
    }
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(milestoneActions.deleteMilestoneAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(milestoneActions.deleteMilestoneAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(milestoneActions.deleteMilestoneAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateMilestoneFlag(state) {
  try {
    yield put(milestoneActions.updateMilestoneFlagAttempt.pending);
    yield call(milestoneApi.updateMilestoneFlag, {
      id: state.payload.id,
      data: state.payload.data,
    });
    yield put(milestoneActions.updateMilestoneFlagAttempt.success());
    if(state.payload.callback){
      state.payload.callback();
    }
  } catch (error) {
    yield put(milestoneActions.updateMilestoneFlagAttempt.error(error.message));
  }
}

function* clearCurrentMilestone() {
  yield put(milestoneActions.clearCurrentMilestoneAttempt.success);
}

function* resetMilestoneErrors() {
  yield put(milestoneActions.resetMilestoneErrorsAttempt.success);
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.MILESTONE_CALL, getMilestones),
    takeEvery(ACTIONS.CREATE_MILESTONE_CALL, createMilestone),
    takeEvery(ACTIONS.UPDATE_MILESTONE_CALL, updateMilestone),
    takeEvery(ACTIONS.DELETE_MILESTONE_CALL, deleteMilestone),
    takeEvery(ACTIONS.MILESTONE_FLAG_CALL, updateMilestoneFlag),
    takeEvery(ACTIONS.MILESTONE_DETAILS_CALL, getMilestoneItemDetails),
    takeEvery(ACTIONS.CLEAR_CURRENT_MILESTONE_CALL, clearCurrentMilestone),
    takeEvery(ACTIONS.RESET_MILESTONE_ERRORS_CALL, resetMilestoneErrors),

  ]);
}
